//@ts-check
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Formatter from '../../../formatter';
import Modals from '../../../modal';
import Button from '../../../core/Button';
import PageCommon from '../../Common';
import PageToolBar from '../../ToolBar';
import DataGrid from '../../../data/Grid';

var SubscriptionsPage = function SubscriptionsPage(_ref) {
  var history = _ref.history;
  /**@type {import('core/Icon/types').IconProps} */

  var icon = undefined;

  if (history) {
    icon = {
      type: 'close',
      onClick: undefined
    };

    if (history.return) {
      icon.onClick = function () {
        return history.return('/settings');
      };
    }
  }

  return React.createElement(React.Fragment, null, React.createElement(PageToolBar, {
    icon: icon,
    leftChildren: "Subscriptions Configuration",
    color: "navbar"
  }), React.createElement(PageCommon, null, React.createElement(Grid, {
    container: true
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Typography, {
    variant: "h6"
  }, "Subscriptions")), React.createElement(Grid, {
    item: true,
    xs: true
  }), React.createElement(Grid, {
    item: true
  }, React.createElement(Button, {
    onClick: function onClick() {
      return Modals.open({
        type: Modals.TYPES.MANAGE_SUBSCRIPTION
      });
    }
  }, "New"))), React.createElement(DataGrid, {
    id: "allSubscriptions",
    dataType: "subscription",
    viewProps: {
      hideModeSwitcher: true
    },
    styles: {
      elevation: 0,
      hideBorder: true
    }
  })));
};

SubscriptionsPage.defaultProps = {};
export default SubscriptionsPage;